import { render, staticRenderFns } from "./RegisterSelect.vue?vue&type=template&id=05c94590&"
import script from "./RegisterSelect.vue?vue&type=script&lang=js&"
export * from "./RegisterSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports